import React, { useEffect, useRef, useState } from "react";
import "./UiButtons.css";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import { usePopup } from "src/contexts/PopupContext";
import { useLoader } from "src/contexts/LoaderContext";
import { Tooltip, TooltipRefProps } from "react-tooltip";
import { useView } from "src/contexts/ViewContext";

const AddToCartIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
    >
      <path
        d="M26.5234 24.9921H9.95312C9.67969 24.9921 9.46094 24.8827 9.35156 24.6639C9.1875 24.4452 9.1875 24.1718 9.29688 23.953L10.7188 20.3436L9.29688 6.8905H4.70312V5.35925H9.95312C10.3359 5.35925 10.6641 5.63269 10.7188 6.0155L12.25 20.2889C12.25 20.3983 12.25 20.5077 12.1953 20.6718L11.1016 23.4061H26.5234V24.9921Z"
        fill="white"
      />
      <path
        d="M11.6484 21.2185L11.3203 19.7419L28.7656 16.1326V9.95288H10.7188V8.42163H29.5312C29.9688 8.42163 30.2969 8.74976 30.2969 9.18726V16.7341C30.2969 17.1169 30.0234 17.3904 29.6953 17.4451L11.6484 21.2185ZM27.2891 29.531C25.6484 29.531 24.2812 28.1638 24.2812 26.5232C24.2812 24.8826 25.6484 23.5154 27.2891 23.5154C28.9297 23.5154 30.2969 24.8826 30.2969 26.5232C30.2969 28.1638 28.9297 29.531 27.2891 29.531ZM27.2891 24.9919C26.4688 24.9919 25.7578 25.6482 25.7578 26.5232C25.7578 27.3982 26.4141 28.0544 27.2891 28.0544C28.1641 28.0544 28.8203 27.3982 28.8203 26.5232C28.8203 25.6482 28.1094 24.9919 27.2891 24.9919ZM9.24219 29.531C7.60156 29.531 6.23438 28.1638 6.23438 26.5232C6.23438 24.8826 7.60156 23.5154 9.24219 23.5154C10.8828 23.5154 12.25 24.8826 12.25 26.5232C12.25 28.1638 10.8828 29.531 9.24219 29.531ZM9.24219 24.9919C8.42188 24.9919 7.71094 25.6482 7.71094 26.5232C7.71094 27.3982 8.36719 28.0544 9.24219 28.0544C10.1172 28.0544 10.7734 27.3982 10.7734 26.5232C10.7734 25.6482 10.0625 24.9919 9.24219 24.9919Z"
        fill="white"
      />
    </svg>
  );
};

const SaveOfferIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
    >
      <mask
        id="mask0_745_1019"
        maskUnits="userSpaceOnUse"
        x="0"
        y="16"
        width="26"
        height="11"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.712891 16.5334H25.2872V26.5176H0.712891V16.5334Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_745_1019)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.77194 16.5334C1.18786 16.5334 0.712891 17.0084 0.712891 17.5925V23.1773C0.712891 25.0191 2.21143 26.5176 4.05323 26.5176H21.947C23.7888 26.5176 25.2873 25.0191 25.2873 23.1773V17.5925C25.2873 17.0084 24.8124 16.5334 24.2283 16.5334C23.6442 16.5334 23.1692 17.0084 23.1692 17.5925V23.1773C23.1692 23.851 22.6207 24.3996 21.947 24.3996H4.05323C3.37957 24.3996 2.83098 23.851 2.83098 23.1773V17.5925C2.83098 17.0084 2.35601 16.5334 1.77194 16.5334Z"
          fill="#170E0E"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.43163 12.201C7.02539 12.201 6.65641 12.4409 6.49144 12.8121C6.32646 13.1833 6.39564 13.6179 6.6675 13.9195L12.2364 20.0902C12.6257 20.5221 13.3748 20.5221 13.7642 20.0902L19.333 13.9195C19.6049 13.6179 19.6741 13.1833 19.5091 12.8121C19.3441 12.4409 18.9751 12.201 18.5689 12.201H14.6498V7.79007C14.6498 6.88048 13.9096 6.14075 13.0005 6.14075C12.0909 6.14075 11.3507 6.88048 11.3507 7.79007V12.201H7.43163Z"
        fill="#170E0E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9994 0.482422C12.0898 0.482422 11.3501 1.22216 11.3501 2.13175V2.39252C11.3501 3.30166 12.0898 4.04184 12.9994 4.04184C13.909 4.04184 14.6487 3.30166 14.6487 2.39252V2.13175C14.6487 1.22216 13.909 0.482422 12.9994 0.482422Z"
        fill="#170E0E"
      />
    </svg>
  );
};

const UiButtons: React.FC = () => {
  const { request, uncompletedTabs } = useConfiguration();
  const {
    setIsSaveOfferFormVisible,
    setResultPopupText,
    setIsResultPopupVisible,
  } = usePopup();
  const {
    setIsMainLoaderVisible,
    setMainLoaderText,
    setIsWhiteSceneLoaderVisible,
  } = useLoader();
  const { isAdmin } = useView();

  const tooltips = {
    1: useRef<TooltipRefProps>(null),
    2: useRef<TooltipRefProps>(null),
    3: useRef<TooltipRefProps>(null),
    4: useRef<TooltipRefProps>(null),
    5: useRef<TooltipRefProps>(null),
    6: useRef<TooltipRefProps>(null),
  };

  const showTooltips = () => {
    uncompletedTabs.forEach((id: number) => {
      // @ts-ignore
      tooltips[id].current?.open({
        anchorSelect: `#tab-number-${id}`,
      });
    });

    setTimeout(() => {
      uncompletedTabs.forEach((id: number) => {
        // @ts-ignore
        tooltips[id].current?.close();
      });
    }, 3000);
  };

  const addOrder = async () => {
    // if (!isAdmin() && uncompletedTabs.size > 0) {
    //     showTooltips();
    //     return;
    // }

    setIsWhiteSceneLoaderVisible(true);
    setMainLoaderText(
      "Werk in uitvoering. We plaatsen uw overkapping nu in de winkelwagen."
    );
    setIsMainLoaderVisible(true);

    try {
      await request.addOrder();
    } catch (error) {
      console.error("Error adding order:", error);
      setIsMainLoaderVisible(false);
      setIsWhiteSceneLoaderVisible(false);
      setResultPopupText("Er is iets misgegaan. Probeer het later opnieuw.");
      setIsResultPopupVisible(true);
    }
  };

  const handleOpenForm = () => {
    // if (!isAdmin() && uncompletedTabs.size > 0) {
    //     showTooltips();
    //     return;
    // }

    setIsSaveOfferFormVisible(true);
  };

  return (
    <>
      <div className={"ui-buttons"}>
        {/* <button className="add-to-cart-button" onClick={addOrder}>
                    <AddToCartIcon/>
                    <span>In winkelwagen</span>
                </button> */}
        <button className="save-offer-button" onClick={handleOpenForm}>
          {/* <SaveOfferIcon /> */}
          <span>{"Opslaan & Offerte".toUpperCase()}</span>
        </button>
      </div>
      <Tooltip
        ref={tooltips[1]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
      <Tooltip
        ref={tooltips[2]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
      <Tooltip
        ref={tooltips[3]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
      <Tooltip
        ref={tooltips[4]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
      <Tooltip
        ref={tooltips[5]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
      <Tooltip
        ref={tooltips[6]}
        className={"tab-tooltip-container"}
        content="Selecteer optie(s) en kies Ok"
        render={() => (
          <div className="tab-tooltip">
            <span>!</span>
            <span>Selecteer optie(s) en kies Ok</span>
          </div>
        )}
        noArrow={false}
        style={{
          backgroundColor: "#ffffff",
          width: "200px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#929292",
          padding: "0",
          boxShadow: "0px 4px 5.3px 0px rgba(0, 0, 0, 0.11)",
          color: "#333333",
          borderRadius: "1px",
        }}
      />
    </>
  );
};

export default UiButtons;
